import default_image from './assets/male.png';
import hani from './assets/w-hani.jpg';
import selena from './assets/w-selena.jpg';
import luffy from './assets/w-luffy.jpg';
import jilan from './assets/w-jilan.jpeg';
import dian from './assets/w-dian.jpg';
import desih from './assets/w-desih.jpeg';
import ajeng from './assets/w-ajeng.jpeg';
import lusi from './assets/w-lusi.jpg';
import ugi from './assets/w-ugi.jpeg';
import widi from './assets/w-widi.jpeg';
import jaozah from './assets/w-jaozah.jpg';
import nia from './assets/w-nia.jpg';
import hasna from './assets/w-hasna.jpeg';
import ulfi from './assets/w-ulfi.png';
import rega from './assets/w-rega.jpg';
import wilfan from './assets/w-wilfan.jpg';
import aulia from './assets/w-aulia.jpg';
import miranti from './assets/w-miranti.jpg';
import zahralita from './assets/w-zahralita.jpg';

export const wishlist = [
  {
    name: 'Hani',
    infoName: 'Teman SMP yayuk',
    description: `"Maa sya Allah... Alhamdulillah yayuk🤗
    Mugia lancar saterasna
    Aamiin☺️"`,
    image: hani,
  },
  {
    name: 'My moon',
    infoName: 'GPWC ❣️',
    description: `"Barakallah febrinnn🥰 semoga Allah selalu memberi jalan terbaik untuk kamu❤️ Cinta yang di awali dengan Ridha Allah dan niat yang baik pasti akan selalu ada dalam lindungan serta limpahan  kasih sayang Allah, insyaa Allah ❤️ Ily ❤️"`,
    image: default_image,
  },
  {
    name: 'Selena Gemesh',
    infoName: "febrii's friend",
    description: `"MashaAllah akhirnyaa ain🥺🥺🥺sebentar lg km akan mengarungi bahtera rumah tangga.. didepan nanti akan ada ujian dan rintangan yg datang silih berganti, semoga Allah senantiasa memberikan kalian kekuatan utk bs sama2 menghadapinya✨
    bingung mau ngomong apalagi, yaa intinya smg bahagia Sedunia dan Seakhirat🥺"`,
    image: selena,
  },
  {
    name: 'Zalfa ',
    infoName: 'Teman kuliah Yayuk di Himi',
    description: `"Maa syaa Allah, Baarakallah bebb. Mudah2an dikasih kelancaran gaa sampai hati H nantiiii🤩🤩💖
    Sehat sehat calon pengantin🤍"`,
    image: default_image,
  },
  {
    name: 'Monkey D Luffy',
    infoName: 'Temen Muallimien Yayuk ',
    description: `"Baarakallahulaka Wabaaraka A'laika Wajamaa' bainakuma fii khair🤩"`,
    image: luffy,
  },
  {
    name: 'Jiilaan aaqilah maqdis',
    infoName: 'Teman yayuk 😆',
    description: `"Hay febrinn... udah lama kita gak pernah bertemu dan komunikasi. Selamat ya yayuk, semoga lancar sampai hari H. Semoga pernikahan yayuk pernikahan yg bisa bawa yayuk dan suami ke syurga nya allah. Aminn.. "`,
    image: jilan,
  },
  {
    name: 'Dian Kurniawan ',
    infoName: 'Teman sekaligus sodara bayu',
    description: `"selamat menempuh hidup baru buat sodaraku bayu dan Yayuk semoga menjadi keluarga yang sakinah,mawadah,warahmah ,semoga selalu dlm ridho Allah SWT dan di limpahi keberkahan ny serta selalu di mudahkan urusanny dalam langkah2 berikutny 🤲🤲😇"`,
    image: dian,
  },
  {
    name: 'Desih Bieber',
    infoName: 'Temen NgeJournal Bayu',
    description: `"Ihiiiiw alhamdulillaah akhirnya bayu sold out juga, ga jadi ceng2an lagi digroup 🤣
    semoga sakinah mawaddah warohmah yaa, bayu dan calon istri. dipasihan kalancaran kanggo sadayana, sehat2 calon manten..
    yuyur insyekyuuur banget liat temen2 bayu sama yayuk ini 😫"`,
    image: desih,
  },
  {
    name: 'Jengsil',
    infoName: 'Temen ngOdoo-nya Bayu',
    description: `"Barakallah Mifs & Yayuk. Alhamdulillah undangan yg ditunggu tunggu akhirnya datang, sold out semua temen seperjuangan Odoo 😆. Semoga lancar acaranya menjadi keluarga yang Sakinah mawaddah warahmah saling memiliki saling melengkapi uwu 😙. Gas keun mifs abi tos 2 yeuh !! 🤣"`,
    image: ajeng,
  },
  {
    name: 'Teh neng dia',
    infoName: 'Sodaranya bayu',
    description: `"Barrkallah sodaraku de mimif sama de Yayuk, semoga menjadi keluarga yang sakinah mawadah warahmah, lancar sampai hari-H nya, AminYaAllahAmin 🤲🏻"`,
    image: default_image,
  },
  {
    name: 'Rose Blackpink (Ai Lusi)',
    infoName: 'Adik kesayangan a Bayu meureun😂',
    description: `"Selamat melepas masa lajang mass bro semoga lancar sampai hari H, aduhh jadi sedihhh ieu tehh😅yang tadinya kemana-mana sama adiknya sekarang mah udah ada pawangnya🤭"`,
    image: lusi,
  },
  {
    name: 'Bayu Dwi R.',
    infoName: 'Teman Seperjuangan Bayu saat Ekstensi S1',
    description: `"Barakallah bro Bayu dan Yayuk.
    Semoga pernikahannya senantiasa diberkahi oleh Allah swt. dan menjadi keluarga yang Sakinah, Mawaddah, Warrahmah.. Aamiin ya Allah"`,
    image: default_image,
  },
  {
    name: 'M. Fahmi Munadi',
    infoName: 'Teman SMA Yayuk',
    description: `"Bismillah..
    Tidak ada doa yang paling diharapkan kecuali sakinah, mawadah, warahmah. (Itulah doa saya untuk kalian)

    Semoga cinta kalian tidak hanya di dunia tapi sampai surga Aamiin"`,
    image: default_image,
  },
  {
    name: 'Ugi',
    infoName: 'Aku yang kau sakiti',
    description: `"Harusnya aku yang disana, dampingimu dan bukan dia. Harusnya aku yang kau cinta dan bukan diaaaa.....😂"`,
    image: ugi,
  },
  {
    name: 'Rini Nur Arifah',
    infoName: 'Temam MTS Bayu',
    description: `"Bayu....
    Mudah mudahan pernikahannya langgeng sehidup seSyurga ya..Aamiin ya Alloh..."`,
    image: default_image,
  },
  {
    name: 'Pawang python',
    infoName: 'Misal : teman smp yayuk',
    description: `"Selamat mip, Pokonamah saya insya Allah rek datang langsung..."`,
    image: widi,
  },
  {
    name: 'JaojahHfzh ',
    infoName: 'Sodara bayu ',
    description: `"Barrakallahu laka, selamat menempuh hidup baru de mimif sama de yayuk.semoga menjadi pernikahan yang langgeng, Sakinah,mawadah,warahmah 🤲 bahagia selalu ya!"`,
    image: jaozah,
  },
  {
    name: 'Nia Saidah',
    infoName: 'Teman MTS dan SMA Bayu',
    description: `"Selamat menempuh hidup baru  sahabatku Bayu dan teh Yayuk , 'Barakallahu lakum wa baraka alaikum' (mudah-mudahan Allah memberi kalian keberkahan dan melimpahkan atas kalian keberkahan)." 🤗🤲"`,
    image: nia,
  },
  {
    name: 'Neni ',
    infoName: 'Temen MTS Bayu',
    description: `"Barokallahulaka wabaroka 'alaika wajama'a baina kuma fikhoir... Alhamdulillah akhirnya mif menemukan teman seperjuangan buat ibadah terpanjang, mengikat perjanjian terberat dengan Allah swt, semoga dalam perjuangannya menjadi keluarga yg sakinah, mawadah, warohmah, sampai janah, serta cepat2 dikaruniai anak2 yang soleh solehah... aamiin
    Maaf belum bisa ikut menghadiri acara pernikahannya, hanya bisa mendo'akan semoga lancar segalanya sampai hari H, sehat-sehat semuanya... aamiin"`,
    image: default_image,
  },
  {
    name: 'Nana Gercep',
    infoName: 'Temen nge reog yayuk',
    description: `"Yayuk sobi boyot aku, sobi reog, sobi gemoy, sobi cuwat ciwit. Barakallah ya rin, akhirnya sampe juga di titik ini, yayuk bahagia terus, happy terus, Allah tau hati kmu dan Allah lebih tau mana yang terbaik. Aku bangga banget sama kamu bisa melewati banyak hal, jangan sedih2 rin. Ya Allah aku titipkan sahabat aku yang pernah menghafal kalam-Mu bersamaan dengan ku, aku titipkan semoga selalu dalam penjagaan-Mu dan kasih sayang-Mu, Rahmati dia dan keluarganya, Ridhai perjalanan nya. Semoga Allah selalu balas kebaikan yayuk dengan kebahagian berlimpah dalam setiap hembusan nafas kamu rin, Yayuk mari bertetangga di syurga🤍🤍🤍🤍 A bayu Bawa yayuk ke syurga ya"`,
    image: hasna,
  },
  {
    name: 'joss',
    infoName: 'joss',
    description: `"joss"`,
    image: default_image,
  },
  {
    name: 'Vitraining team',
    infoName: 'Teman satu kantor  dulu ',
    description: `" Yeeee akhirnya a bayu 😇 , ngduluin aku btw 😁 hehe
    Alhamdulillah , barokalloh ya a , semoga semua nya diberikan kelancaran dan keberkahan , 🤲"`,
    image: ulfi,
  },
  {
    name: 'Peter Parker',
    infoName: 'Teman Zigot',
    description: `"Sakinnah mawaddah wa rahmah ceu🙏"`,
    image: default_image,
  },
  {
    name: 'Ceu bestie',
    infoName: 'Bestie nongki',
    description: `"Hwappy Wedding ceu..
    Barakallah bebs🕊🤍 mugia lancar dina sagala proses dugi ka hari H sreng saterasna. Sakinah mawaddah warahmah cantikquu✨️💕
    Selebrasian nya ditunggu wkwk"`,
    image: default_image,
  },
  {
    name: 'Rega & Nurul',
    infoName: 'Teman Kuliah Bayu',
    description: `"Alhamdulillah, selamat untuk Bayu & Yayuk semoga dilancarkan, dimudahkan dan dimuluskan jalan menuju hari H pernikahan serta hidup barunya, mudah-mudahan menjadi keluarga yang sakinah mawaddah warahmah. Aaamiiin... 🤲"`,
    image: rega,
  },
  {
    name: 'Wilfan Setiawan ',
    infoName: 'Teman SMA Bayu ',
    description: `"Alhamdulillah ,ngiring bingah mif

    Selamat menempuh hidup baru kawan ,,semoga lancar semuanya sampai hari H ,dan semoga menjadi keluarga sakinah mawadah warrahmah ..amiin "`,
    image: wilfan,
  },
  {
    name: 'Rizal ',
    infoName: 'Batur guyang di lembur 🤭',
    description: `"WELCOME ON BOARD BROTHER

    Saat perahu mulai berlayar, sangat bijak rasanya untuk tetap bertahan bersama sama meskipun badai terus menerpa !

    Semoga sampai ke tujuan dengan selamat Amin."`,
    image: default_image,
  },
  {
    name: 'Aulia RA',
    infoName: 'Bestie yayuk terbaik',
    description: `"Aaaaaa sedih bercampur senang bestie aku mo nikah🥺 semoga kelak menjadi keluarga yang selalu dipenuhi keberkahan oleh Allah swt, dianugrahi buah hati yang menjadi penyejuk hati untuk orang tuanya, pokoknya doa terbaik untuk kalian berdua🤍🤍"`,
    image: aulia,
  },
  {
    name: 'MIRANTI JAUZAN ',
    infoName: 'TEMAN TEH ARIN DI MQR',
    description: `"Aaaaa MasyaAllah tabarakAllah finally😍bahagia selalu teh Yayuk dan suami!! InsyaAllah selalu Allah jagaa aamiin. Sehat sehat yaaaa. Sending luv dari Riau, kapan kapan reuni MQR yaa hihiw see u tetehkuu!!🥰❤️❤️"`,
    image: miranti,
  },
  {
    name: 'Nur',
    infoName: 'Teman kuliah + Himi Yayuk',
    description: `"Ceuu maa syaa Allah barakallah, sebentar lagi akan menempuh hidup baru yang lebih berwarna! Semoga senantiasa Allah beri banyak berkah dan kebahagiaan! Serta Allah mudahkan dan lancarkan yaa segalanya ❤️ sehat2 calon manten 🥰"`,
    image: default_image,
  },
  {
    name: 'Teh Nuye',
    infoName: 'Temen sekamar di pondok',
    description: `"Barokalloh neng yayuk, waktu memang cepat berlalu yaa, sekarang udh gk bocil lagi😊
Selamat menempuh ibadah terpanjang, selamat menggapai surga bersama pilihan hati.
Semoga Allah swt selalu meridhoi setiap perjalanan rumah tanggamu dan suami."`,
    image: default_image,
  },
  {
    name: 'Zahralita',
    infoName: 'Temen go food yayuk pas di rabbani 😆',
    description: `"Waaa MasyaAllah Barakallahu laka wa baraka alaika wa jamaa bainakuma fii khair ariiiin dan suamik
Tadinya mau datang , tp qodarullah ini masih di jalan, selaly teriring doa buat yayuk dan keluarga, semoga selaly diberkahkan , dilancarkan aamiin ya rabb"`,
    image: zahralita,
  }
];
